import { render } from "./PasswordChangeCard.vue?vue&type=template&id=61ddb8a2&scoped=true"
import script from "./PasswordChangeCard.vue?vue&type=script&lang=js"
export * from "./PasswordChangeCard.vue?vue&type=script&lang=js"

import "./PasswordChangeCard.vue?vue&type=style&index=0&id=61ddb8a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ddb8a2"]])

export default __exports__